import { render, staticRenderFns } from "./order-logistics.vue?vue&type=template&id=26a123c4"
import script from "./order-logistics.vue?vue&type=script&lang=ts"
export * from "./order-logistics.vue?vue&type=script&lang=ts"
import style0 from "./order-logistics.vue?vue&type=style&index=0&id=26a123c4&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports